import { Utils } from '../../../../utils/common'
import { logger } from '../../../../utils/common/logger'
import { IdentityEvent } from '../../../common/events/identity'
import { IIdentityFormFields, IIdentityServiceAdapter, ISubscriberServiceAdapter } from '../adapter'
import { LoginService } from '../loginradius/services/login-service'

export class VerifyAddressForm {
    private static DOM = {
        class: {
            verifyDeliveryAddressSuccess: 'page-verify-delivery-address-success'
        },
        form: 'verifyDeliveryAddressForm'
    }

    constructor(private loginradiusAdapter: IIdentityServiceAdapter,
                private pianoAdapter: ISubscriberServiceAdapter) {
    }

    /**
     * Listens for form validated event
     */
    public async init() {
        logger('debug', 'Initializing verify address form')
        document.addEventListener(IdentityEvent.FORM_VALIDATED,
            async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === VerifyAddressForm.DOM.form) {
                    await this.submitForm()
                }
            }
        )
        logger('debug', 'Verify address form initialized')

        const successPage = document.querySelector(`.${VerifyAddressForm.DOM.class.verifyDeliveryAddressSuccess}`)

        if (successPage) {
            // refresh subscriber resource and term ids
            document.dispatchEvent(Utils.event(IdentityEvent.IDENTITY_CHANGE, {
                conversions: undefined,
                subscriptions: undefined
            }))
            logger('debug', 'Subscriber resource and term ids refreshed')
        }
    }

    /**
     * Calls Login Radius update API and adds the print subscription term
     */
    public async submitForm() {
        const formData = this.getFields()
        LoginService.clearErrors()

        try {
            // call LoginRadius update API
            await this.loginradiusAdapter.updateAccountProfile(formData)

            // call Piano add print subscription term API
            await this.pianoAdapter.addPrintSubscriptionTerm(formData)

            // redirect to success page
            location.assign('/verify-delivery-address-success')
        } catch (e) {
            LoginService.showErrors([{
                Description: 'We are unable to verify your delivery address. Please try again later.',
                ErrorCode: 400
            }])
        }
    }

    /**
     * Returns form fields as a key value pair JSON
     *
     * @return {IIdentityFormFields}
     */
     public getFields(): IIdentityFormFields {
        let data = [] as IIdentityFormFields

        const form = document.querySelector(`[data-id-form]`)

        if (form) {
            const fields = form.querySelectorAll<HTMLInputElement | HTMLSelectElement>(
                '[type=tel], [type=text], select'
            )

            fields.forEach((field) => {
                // convert key to camel case
                const key = (field.name).replace(/[_][a-z1-9]/g, (group) => group.slice(-1).toUpperCase())

                // key value pair
                data = { ...data, [key]: field.value}
            })
        }
        return data
    }
}
